import { IEnvironment } from './interface/IEnvironment.interface';
import { PREFIX, SERVICES } from './path-consts/prefix.env';

export const environment: IEnvironment = {
  state: 'DEVELOPMENT',
  FE_URL: `https://tmtrav-ecommerce-management-${PREFIX.DEV}.tma-swerp.com/`,
  // FE_URL: `https://marketplace-management.tma-swerp.com /`,
  FE_URL_SALE: `https://tmtrav-ecommerce-${PREFIX.DEV}.tma-swerp.com/shopping/`,
  FE_URL_SALE_NO_PREFIX: `https://tmtrav-ecommerce-${PREFIX.DEV}.tma-swerp.com`,
  // FE_URL_SALE: `https://marketplace.tma-swerp.com/`,
  BE_URL: `https://api-${PREFIX.DEV}-tmtrav.tma-swerp.com/`,
  API_URL: `https://api-${PREFIX.DEV}-tmtrav.tma-swerp.com`,
  IMAGE_URL: `https://api-${PREFIX.DEV}.tma-swerp.com/ecommerce-management`,
  FE_SSO_URL: `https://${PREFIX.DEV}-sso.tma-swerp.com/`,
  BE_SSO_URL: `https://api-${PREFIX.DEV}.tma-swerp.com/sso-service/`,
  IFRAME_CONNECT_URL: `https://tmtrav-${PREFIX.DEV}.tma-swerp.com/app-connect`,
  SERVICES: SERVICES,
  MODULE: 'SHOP',
  LOGIN_URL: `https://tmtrav-${PREFIX.DEV}.tma-swerp.com`,
  APP_NAME: 'TMTravel',
  APP_LOGO: 'tmtravel-logo',
  GOSHIP_PRINTDOMAIN: 'https://goship-dev.dayconyeu.com/screenshot?code=',
  SPECIAL_SELLER_DOMAIN_URL: 'https://home-connect-special-seller.tma-swerp.com',
  ECOMMERCE_MANAGEMENT_DOMAIN_URL: `https://tmtrav-ecommerce-management-${PREFIX.DEV}.tma-swerp.com`,
};
